import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import LoanList from '@components/list/loanList'
import LoanFilter from '../loanFilter'
import TablePageHandler from '../tablePageHandler'
import NotLoanCard from '@components/card/NotLoanCard'

import {
  listLoans as listLoansAction,
  listClosedLoans as listClosedLoansAction,
} from '@stores/actions/loan'

import { Container } from './styles'

const OpenLoanTable = ({
  listLoans, loans, total, listClosedLoans
}) => {

  const [searchTerm, setSearchTerm] = useState('')
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [filterState, setFilterState] = useState({
    startDate: null,
    endDate: null,
    timeInterval: null,
    equipments: null,
  })

  useEffect(() => {
    listLoans(
      {
        searchTerm: searchTerm === '' ? null : searchTerm,
        ...filterState,
        status: 0,
        page: page + 1,
        pageSize
      }
    )

  }, [page, pageSize, filterState])

  const onSearchLoans = () => {
    listLoans(
      {
        searchTerm: searchTerm === '' ? null : searchTerm,
        ...filterState,
        status: 0,
        page: page + 1,
        pageSize
      }
    )
  }

  const onRefreshLoansList = () => {
    listLoans(
      {
        searchTerm: searchTerm === '' ? null : searchTerm,
        ...filterState,
        status: 0,
        page: page + 1,
        pageSize
      }
    )
    listClosedLoans(
      {
        searchTerm: searchTerm === '' ? null : searchTerm,
        ...filterState,
        status: 1,
        page: page + 1,
        pageSize
      }
    )
  }

  if (!loans) {
    return null
  }

  return (
    <Container>
      <LoanFilter
        searchTerm={searchTerm}
        onInputChange={setSearchTerm}
        onSearch={onSearchLoans}
        setFilterState={setFilterState}
        isOpen
      />
      {total !== 0
        ? (
          <>
            <LoanList
              loans={loans}
              isOpenLoan
              refreshLoans={onRefreshLoansList}
            />
            <TablePageHandler
              total={total}
              sizeOnPage={loans && loans?.length}
              page={page + 1}
              pageSize={pageSize}
              setPage={setPage}
              setPageSize={setPageSize}
              isLoan
            />
          </>
        ) : (
          <NotLoanCard
            title="Não há empréstimos de equipamentos ativos"
            subtitle="Atualmente, não há empréstimos de equipamentos registrados. Se precisar de assistência ou informações adicionais,
          entre em contato com a Central de Ajuda"
          />
        )}

    </Container>
  )

}

OpenLoanTable.propTypes = {
  listLoans: PropTypes.func.isRequired,
  loans: PropTypes.object,
  total: PropTypes.number,
  listClosedLoans: PropTypes.func.isRequired,
}

OpenLoanTable.defaultProps = {
  loans: null,
  total: 0,
}

const mapStateToProps = ({ loan }) => ({
  loans: loan.loans,
  total: loan.total,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    listLoans: listLoansAction,
    listClosedLoans: listClosedLoansAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(OpenLoanTable)
